import { render, staticRenderFns } from "./EditNotifications.vue?vue&type=template&id=4c205386&scoped=true&"
import script from "./EditNotifications.vue?vue&type=script&lang=js&"
export * from "./EditNotifications.vue?vue&type=script&lang=js&"
import style0 from "./EditNotifications.vue?vue&type=style&index=0&id=4c205386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c205386",
  null
  
)

/* custom blocks */
import block0 from "./EditNotifications.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c205386')) {
      api.createRecord('4c205386', component.options)
    } else {
      api.reload('4c205386', component.options)
    }
    module.hot.accept("./EditNotifications.vue?vue&type=template&id=4c205386&scoped=true&", function () {
      api.rerender('4c205386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user-profile/EditNotifications.vue"
export default component.exports